import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";

const PATH = "logic-trees";

@Injectable({
  providedIn: "root",
})
export class LogicTreesHandlerService {
  constructor(private APIService: ApiService) {}

  getLogicTrees(
    masterAccountID: number,
    queryParams?: {
      facility_id?: number[];
      page?: number;
      perPage?: number;
      filter_columns?: string[];
    },
  ) {
    return this.APIService.get(`${PATH}/${masterAccountID}`, {
      params: queryParams,
    });
  }

  getEntryEvents(
    masterAccountID: number,
    queryParams?: {
      page?: number;
      perPage?: number;
    },
  ) {
    return this.APIService.get(`logic-entry-event-types/${masterAccountID}`, {
      params: queryParams,
    });
  }

  getLogicTree(masterAccountID: number, logicTreeID: number) {
    return this.APIService.get(`${PATH}/${masterAccountID}/${logicTreeID}`);
  }

  deleteLogicTree(masterAccountID: number, logicTreeID: number) {
    return this.APIService.delete(`${PATH}/${masterAccountID}/${logicTreeID}`);
  }

  updateLogicTree(
    masterAccountID: number,
    logicTreeID: number,
    logicTree: any,
  ) {
    return this.APIService.put(
      `${PATH}/${masterAccountID}/${logicTreeID}`,
      logicTree,
    );
  }

  createLogicTree(masterAccountID: number, logicTree: any) {
    return this.APIService.post(`${PATH}/${masterAccountID}`, logicTree);
  }

  getRedemptions(
    masterAccountID: number,
    accountAppID: number,
    queryParams?: {
      facility_id?: number[];
      start?: string;
      end?: string;
      page?: number;
      perPage?: number;
    },
  ) {
    return this.APIService.get(
      `${PATH}/${masterAccountID}/${accountAppID}/redemptions`,
      { params: queryParams },
    );
  }

  getReport(masterAccountID: number, logicTreeID: number, queryParams?: any) {
    return this.APIService.get(
      `${PATH}/${masterAccountID}/${logicTreeID}/report`,
      { params: queryParams },
    );
  }

  getPayloadLookup(masterAccountID: number, name: string, query: string) {
    return this.APIService.get(
      `${PATH}/${masterAccountID}/payload_lookup/${name}/?query=${query}`,
    );
  }
}
